import React from "react";
import DateTime from "react-datetime";
import "react-datetime/css/react-datetime.css";
import moment, { Moment } from "moment";

interface DateTimePickerProps {
  value: Date | string | null;
  onChange: (date: Date | null) => void;
  label?: string;
  error?: boolean;
  errorMsg?: string;
}

const DateTimePicker: React.FC<DateTimePickerProps> = ({ value, onChange, label, error, errorMsg }) => {
  const handleChange = (date: Moment | string) => {
    if (typeof date === "string") {
      // user typed invalid input
      onChange(null);
    } else {
      onChange(date.toDate());
    }
  };
  const isValidDate = (current: Moment) => {
    return current.isSameOrAfter(moment().startOf("day"));
  };

  return (
    <div className="">
      {label && (
        <label className="text-sm text-docsigna-blue-dark font-medium block w-full mb-1">
          {label}
          <span className="text-red-500">*</span>
        </label>
      )}
      <DateTime
        className="font-medium"
        value={value ? moment(value) : undefined}
        onChange={handleChange}
        dateFormat="YYYY-MM-DD"
        timeFormat="HH:mm"
        isValidDate={isValidDate}
        inputProps={{
          className: "w-full border rounded-[6px] p-2",
          placeholder: "Select date & time",
        }}
      />
      {error && errorMsg && <p className="text-red-500">{errorMsg}</p>}
    </div>
  );
};

export default DateTimePicker;
